export default __webpack_public_path__ + "static/media/DSC_0638.56344006.JPG";